import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { draftT7 } from "../utils/constants";
//import { SvgLoader, SvgProxy } from "react-svgmt";
/* import _ from "lodash"; */
import { useMatchContext } from "../context/match_context";
import {
  AW_PLAYER_A,
  AW_PLAYER_B,
  AW_BOTH_PLAYERS,
  AW_REMOVE,
} from "../utils/constants";
import {
  /* GameIdManagement, */
  GameResultsManagement,
  Lightbox,
} from "../components";

const MatchDetailManage = ({ isAdmin }) => {
  const { loading, error, match, updateMatch } = useMatchContext();
  /*   const [previousMatch, setPreviousMatch] = useState(match);*/
  const [showErrorDraftMap, setShowErrorDraftMap] = useState("");
  const [showErrorDraftCiv, setShowErrorDraftCiv] = useState("");
  const [gamesFormatSystem, setGamesFormatSystem] = useState();
  const [mapDraft, setMapDraft] = useState(
    match.mapDraft ? match.mapDraft : ""
  );
  const [civDraft, setCivDraft] = useState(
    match.civDraft ? match.civDraft : ""
  );
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const images = [
    "https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/map_pool_t7.png",
  ];

  const onBlurDraft = (setShowErrorDraft, value) => {
    if (value === null || value.length === 0) {
      setShowErrorDraft("* Este campo no puede quedar vacío.");
      return;
    }

    // Allowed formats: https://aoe2cm.net/draft/sbWUs, https://aoe2cm.net/spectate/sbWUs, https://www.aoe2cm.net/draft/sbWUs, https://www.aoe2cm.net/spectate/sbWUs
    const regex = /https:\/\/(www\.)*aoe2cm\.net\/(draft|spectate)\//gm;

    var m = regex.exec(value);
    if (m !== null) {
      console.log("expresion ok");
      console.log(m);
      setShowErrorDraft("");
    } else {
      setShowErrorDraft(
        "* El formato de la URL es incorrecto. Por favor copia la URL del draft y pégala aquí. Debería ser algo parecido a: https://aoe2cm.net/draft/xxxxx o https://www.aoe2cm.net/spectate/xxxx"
      );
    }
  };

  const awOptionSelected = (option) => {
    if (option === AW_PLAYER_A) {
      updateMatch({
        ...match,
        playerAaw: "AW",
        playerBaw: "",
        playerAresult: 3,
        playerBresult: 0,
        status: "REVIEWED",
      });
    }
    if (option === AW_PLAYER_B) {
      updateMatch({
        ...match,
        playerAaw: "",
        playerBaw: "AW",
        playerAresult: 0,
        playerBresult: 3,
        status: "REVIEWED",
      });
    }
    if (option === AW_BOTH_PLAYERS) {
      updateMatch({
        ...match,
        playerAaw: "AL",
        playerBaw: "AL",
        playerAresult: 0,
        playerBresult: 0,
        status: "REVIEWED",
      });
    }
    if (option === AW_REMOVE) {
      updateMatch({
        ...match,
        playerAaw: "",
        playerBaw: "",
        playerAresult: 0,
        playerBresult: 0,
        status: "NOT_STARTED",
      });
    }
  };

  useEffect(() => {
    if (match && match.gamesFormat === "BO5") {
      setGamesFormatSystem(draftT7.draft_BO5);
    }
    if (match && match.gamesFormat === "PA3") {
      setGamesFormatSystem(draftT7.draft_PA3);
    }
  }, [match]);

  useEffect(() => {
    // Allowed formats: https://aoe2cm.net/draft/sbWUs, https://aoe2cm.net/draft/sbWUs, https://www.aoe2cm.net/draft/sbWUs, https://www.aoe2cm.net/draft/sbWUs
    const regex = /https:\/\/(www\.)*aoe2cm\.net\/(draft|spectate)\//gm;

    var map = regex.exec(mapDraft);
    var civ = regex.exec(civDraft);
    if (map !== null || civ !== null) {
      /* console.log(">>> actualizados drafts"); */
      updateMatch({ ...match, mapDraft: mapDraft, civDraft: civDraft });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [civDraft, mapDraft]);

  if (loading) {
    return <Wrapper>Loading data...</Wrapper>;
  }
  if (error) {
    return <Wrapper>Error cargando la info de la partida.</Wrapper>;
  }

  return (
    <Wrapper>
      <div className="result">
        <span className="aw">{match.playerAaw}</span> {match.playerAresult}
        {" : "}
        {match.playerBresult} <span className="aw">{match.playerBaw}</span>
      </div>
      <MatchDate>
        {isAdmin ? (
          <AdminOptions>
            <h4>Opciones de Admin</h4>
            <div className="match-status">
              <h5>Estado de la partida</h5>
              <p>Actual: {match.status}</p>
              <button
                className="btn"
                onClick={() =>
                  updateMatch({
                    ...match,
                    status: "REVIEWED",
                  })
                }
              >
                Marcar como REVISADO
              </button>
              <i>
                El estado REVISADO supone que el admin ha realizado una revisión
                y está toda la información de la partida bien cubierta. Desde
                ese momento la partida ya no podrá ser editada por los jugadores
                y en caso de error solo un admin podrá modificarla.
              </i>
            </div>

            <div className="aw-options">
              <h5>Admin Wins</h5>
              <div
                className={`aw-selector ${
                  match.playerAaw === "AW" ? "aw-selected" : ""
                }`}
                onClick={() => awOptionSelected(AW_PLAYER_A)}
              >
                AW para {match.playerAusername}
              </div>
              <div
                className={`aw-selector ${
                  match.playerBaw === "AW" ? "aw-selected" : ""
                }`}
                onClick={() => awOptionSelected(AW_PLAYER_B)}
              >
                AW para {match.playerBusername}
              </div>
              <div
                className={`aw-selector ${
                  match.playerAaw === "AL" && match.playerBaw === "AL"
                    ? "aw-selected"
                    : ""
                }`}
                onClick={() => awOptionSelected(AW_BOTH_PLAYERS)}
              >
                AL ambos jugadores
              </div>
              <div
                className={`aw-selector`}
                onClick={() => awOptionSelected(AW_REMOVE)}
              >
                <span role="img" aria-label="tache">
                  ❌
                </span>{" "}
                Borrar AWs y dejar pendiente
              </div>
            </div>
          </AdminOptions>
        ) : (
          ""
        )}
        <h2>FECHA</h2>
        date picker
      </MatchDate>
      <Drafts>
        <h2>ANTES DE EMPEZAR...</h2>
        <p>A continuación un resumen de los pasos para jugar:</p>
        <h3>Info útil</h3>
        <p>Info que te puede ser útil:</p>
        <div className="usefull-info">
          <div
            className="usefull-info-image"
            onClick={() => {
              setIsOpen(true);
            }}
          >
            <span>Pool mapas</span>
            <figure>
              <img
                src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/map_pool_t7.png"
                alt="pool mapas"
              />
            </figure>
          </div>

          <a
            href="https://docs.google.com/document/d/14ztVrO-8fSY5Mfn_tHre5ueHB7WSZBIq/edit?usp=sharing&ouid=101891344918082115048&rtpof=true&sd=true"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="btn space-around">Handbook</button>
          </a>
        </div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + images.length - 1) % images.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % images.length)
            }
          />
        )}
        <h3>1º Draft de mapas</h3>
        <a
          href={gamesFormatSystem ? gamesFormatSystem.mapLink : ""}
          target="_blank"
          rel="noopener noreferrer"
          className="draft"
        >
          {/* {gamesFormatSystem
            ? gamesFormatSystem.mapTurns.map((turn) => {
                const color =
                  turn.player === "playerA"
                    ? "var(--clr-playerA)"
                    : "var(--clr-playerB)";
                var icon = "";

                if (turn.action === "PICK") {
                  icon =
                    "https://alexocampos.github.io/liga-espanhola-aoe2-static/draft/map-pick.svg";
                }

                if (turn.action === "BAN") {
                  icon =
                    "https://alexocampos.github.io/liga-espanhola-aoe2-static/draft/ban.svg";
                }

                return (
                  <div key={`draft-map-turn-${turn.turn}`}>
                    <SvgLoader path={icon}>
                      <SvgProxy selector={"path"} stroke={color} fill={color} />
                      <SvgProxy selector={"rect"} stroke={color} />
                    </SvgLoader>
                  </div>
                );
              })
            : ""} */}
        </a>
        (<b>Anfitrión:</b> {match.playerAusername}; <b>Invitado:</b>{" "}
        {match.playerBusername})
        <input
          className="input-text-field-big"
          type="text"
          placeholder="https://www.aoe2cm.net/spectate/xxxxxx"
          value={mapDraft}
          name="map_pick"
          onChange={(event) => setMapDraft(event.target.value)}
          onBlur={() => onBlurDraft(setShowErrorDraftMap, mapDraft)}
        />
        <p className="error-msg">{showErrorDraftMap}</p>
        <h3>2º Draft de civis</h3>
        <a
          href={gamesFormatSystem ? gamesFormatSystem.civLink : ""}
          target="_blank"
          rel="noopener noreferrer"
          className="draft"
        >
          {/* {gamesFormatSystem
            ? gamesFormatSystem.civTurns.map((turn) => {
                const color =
                  turn.player === "playerA"
                    ? "var(--clr-playerA)"
                    : "var(--clr-playerB)";
                var icon = "";

                if (turn.action === "PICK") {
                  icon =
                    "https://alexocampos.github.io/liga-espanhola-aoe2-static/draft/civ-pick.svg";
                }

                if (turn.action === "BAN") {
                  icon =
                    "https://alexocampos.github.io/liga-espanhola-aoe2-static/draft/ban.svg";
                }

                if (turn.action === "SNIPE") {
                  icon =
                    "https://alexocampos.github.io/liga-espanhola-aoe2-static/draft/ban.svg";
                }

                return (
                  <div key={`draft-civ-turn-${turn.turn}`}>
                    <SvgLoader path={icon}>
                      <SvgProxy selector={"path"} stroke={color} fill={color} />
                      <SvgProxy selector={"rect"} stroke={color} />
                      <SvgProxy selector={"circle"} stroke={color} />
                    </SvgLoader>
                  </div>
                );
              })
            : ""} */}
        </a>
        (<b>Anfitrión:</b> {match.playerAusername}; <b>Invitado:</b>{" "}
        {match.playerBusername})
        <input
          className="input-text-field-big"
          type="text"
          placeholder="https://www.aoe2cm.net/spectate/xxxxxx"
          value={civDraft}
          name="civ_pick"
          onChange={(event) => setCivDraft(event.target.value)}
          onBlur={() => onBlurDraft(setShowErrorDraftCiv, civDraft)}
        />
        <p className="error-msg">{showErrorDraftCiv}</p>
      </Drafts>
      <Games>
        <h2>A JUGAR!</h2>
        <article>
          <div className="infoBox" style={{ fontSize: "1rem" }}>
            Temas a tener en cuenta IMPORTANTES:
            <ul>
              <li>&gt; Poned la partida PÚBLICA</li>
              <li>&gt; Uníos a un canal de voz de la liga. Es OBLIGATORIO</li>
            </ul>
          </div>
        </article>
        <div style={{ marginBottom: "2rem" }}>
          Sistema de competición: <b>{match.gamesFormat}</b> (
          {match.gamesFormat === "PA3" ? (
            <i>Se juegan los 3 mapas siempre</i>
          ) : (
            ""
          )}
          {match.gamesFormat === "BO5" ? (
            <i>
              Se juega al mejor de 5, es decir, el primero en ganar 3 mapas
              gana.
            </i>
          ) : (
            ""
          )}
          )
        </div>
        <div>
          <p>Orden de juego de las partidas:</p>
          {match.gamesFormat === "PA3" ? (
            <ul>
              <li>1. HM {match.playerAusername}</li>
              <li>2. HM {match.playerBusername}</li>
              <li>3. 3º mapa</li>
            </ul>
          ) : (
            ""
          )}
          {match.gamesFormat === "Bo5" ? (
            <ul>
              <li>1. HM {match.playerAusername}</li>
              <li>2. HM {match.playerBusername}</li>
              <li>3. Mapa neutro</li>
              <li>4. HM del que vaya perdiendo</li>
              <li>5. Último mapa que queda</li>
            </ul>
          ) : (
            ""
          )}
        </div>
        {/* <GameIdManagement /> */}
      </Games>
      <Results>
        <h2>PUBLICAR RESULTADOS</h2>
        <GameResultsManagement />
      </Results>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100%;
  @media (max-width: 800px) {
  }
`;

const AdminOptions = styled.div`
  background-color: var(--clr-dark-violet);
  padding: 1rem;
  margin-bottom: 2rem;

  .aw-options {
    border: 1px solid var(--clr-grey-1);
    border-style: dashed solid;
    padding: 0.7rem;
  }

  .aw-selector {
    margin: 1.4rem;
    border: solid 1px var(--clr-grey-1);
    padding: 0.6rem;
    color: var(--clr-grey-1);
    cursor: pointer;
  }

  .aw-selector:hover {
    background-color: var(--clr-grey-1);
    color: var(--clr-black);
  }

  .aw-selected {
    background-color: var(--clr-grey-1);
    color: var(--clr-black);
  }
  .match-status {
    border: 1px solid var(--clr-grey-1);
    border-style: dashed solid;
    padding: 0.7rem;
    margin-bottom: 1.4rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .btn {
      margin: 0.4rem;
    }
  }
`;

const MatchDate = styled.section`
  display: flex;
  flex-direction: column;

  .btn {
    margin-top: 3rem;
    width: 12rem;
  }

  @media (max-width: 800px) {
  }

  /* Date Picker */
  .date-picker {
    width: 12rem;
    color: var(--clr-grey-1);
    cursor: pointer;
  }

  .react-datetime-picker {
    display: inline-flex;
    position: relative;
    color: var(--clr-grey-1);
  }
  .react-datetime-picker,
  .react-datetime-picker *,
  .react-datetime-picker *:before,
  .react-datetime-picker *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-datetime-picker--disabled {
    background-color: #f0f0f0;
    color: var(--clr-grey-1);
  }
  .react-datetime-picker__wrapper {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    border: thin solid gray;
  }
  .react-datetime-picker__inputGroup {
    min-width: calc(4px + (4px * 3) + 0.54em * 6 + 0.217em * 2);
    flex-grow: 1;
    padding: 0 2px;
    cursor: pointer;
  }
  .react-datetime-picker__inputGroup__divider {
    padding: 1px 0;
    white-space: pre;
  }
  .react-datetime-picker__inputGroup__input {
    min-width: 0.54em;
    height: calc(100% - 2px);
    position: relative;
    padding: 1px;
    border: 0;
    background: none;
    font: inherit;
    box-sizing: content-box;
    -moz-appearance: textfield;
    color: var(--clr-grey-1);
    cursor: pointer;
  }
  .react-datetime-picker__inputGroup__input::-webkit-outer-spin-button,
  .react-datetime-picker__inputGroup__input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .react-datetime-picker__inputGroup__input:invalid {
    background: rgba(255, 0, 0, 0.1);
  }
  .react-datetime-picker__inputGroup__input--hasLeadingZero {
    margin-left: -0.54em;
    padding-left: calc(1px + 0.54em);
  }
  .react-datetime-picker__inputGroup__amPm {
    font: inherit;
    -moz-appearance: menulist;
  }
  .react-datetime-picker__button {
    border: 0;
    background: transparent;
    padding: 4px 6px;
  }
  .react-datetime-picker__button:enabled {
    cursor: pointer;
  }
  .react-datetime-picker__button:enabled:hover
    .react-datetime-picker__button__icon,
  .react-datetime-picker__button:enabled:focus
    .react-datetime-picker__button__icon {
    stroke: #0078d7;
  }
  .react-datetime-picker__button:disabled .react-datetime-picker__button__icon {
    stroke: #6d6d6d;
  }
  .react-datetime-picker__button svg {
    display: inherit;
  }
  .react-datetime-picker__calendar,
  .react-datetime-picker__clock {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1;
  }
  .react-datetime-picker__calendar--closed,
  .react-datetime-picker__clock--closed {
    display: none;
  }
  .react-datetime-picker__calendar {
    width: 350px;
    max-width: 100vw;
  }
  .react-datetime-picker__calendar .react-calendar {
    border-width: thin;
  }
  .react-datetime-picker__clock {
    width: 200px;
    height: 200px;
    max-width: 100vw;
    padding: 25px;
    background-color: white;
    border: thin solid #a0a096;
  }
  .react-datetime-picker__clear-button svg {
    stroke: var(--clr-grey-1);
  }
  .react-datetime-picker__calendar-button svg {
    stroke: var(--clr-grey-1);
  }

  /* calendar */
  .react-calendar {
    width: 350px;
    max-width: 100%;
    background: white;
    border: 1px solid #a0a096;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.125em;
  }
  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar__navigation {
    display: flex;
    height: 44px;
    margin-bottom: 1em;
  }
  .react-calendar__navigation button {
    min-width: 44px;
    background: none;
  }
  .react-calendar__navigation button:disabled {
    background-color: #f0f0f0;
  }
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.75em;
  }
  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    font-weight: bold;
  }
  .react-calendar__month-view__days__day--weekend {
    color: #d10000;
  }
  .react-calendar__month-view__days__day--neighboringMonth {
    color: #757575;
  }
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }
  .react-calendar__tile {
    max-width: 100%;
    padding: 10px 6.6667px;
    background: none;
    text-align: center;
    line-height: 16px;
  }
  .react-calendar__tile:disabled {
    background-color: #f0f0f0;
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__tile--now {
    background: #ffff76;
  }
  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: #ffffa9;
  }
  .react-calendar__tile--hasActive {
    background: #76baff;
  }
  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    background: #a9d4ff;
  }
  .react-calendar__tile--active {
    background: #006edc;
    color: white;
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: #1087ff;
  }
  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #e6e6e6;
  }

  /* Clock */
  .react-clock {
    display: block;
    position: relative;
  }
  .react-clock,
  .react-clock *,
  .react-clock *:before,
  .react-clock *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-clock__face {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 1px solid black;
    border-radius: 50%;
  }
  .react-clock__hand {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    right: 50%;
  }
  .react-clock__hand__body {
    position: absolute;
    background-color: black;
    transform: translateX(-50%);
  }
  .react-clock__mark {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    right: 50%;
  }
  .react-clock__mark__body {
    position: absolute;
    background-color: black;
    transform: translateX(-50%);
  }
  .react-clock__mark__number {
    position: absolute;
    left: -40px;
    width: 80px;
    text-align: center;
  }
  .react-clock__second-hand__body {
    background-color: red;
  }
`;

const Drafts = styled.section`
  margin-top: 3rem;
  h2 {
    margin-top: 3rem;
  }
  h3 {
    margin-top: 1rem;
    font-size: 1.2rem;
  }

  .draft {
    display: flex;
    cursor: pointer;
    flex-wrap: wrap;
  }

  .error-msg {
    color: var(--clr-primary-light-3);
    font-style: italic;
  }

  .usefull-info {
    display: flex;
    margin-bottom: 3rem;
    justify-content: center;
    align-items: center;
  }
  .usefull-info span {
    font-size: 1rem;
  }
  .usefull-info-image {
    cursor: pointer;
  }
  .usefull-info-image figure {
    margin-right: 2rem;
    position: relative;
    overflow: hidden;
    width: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .usefull-info-image img {
    width: 10rem;
  }
  .usefull-info-image figure::before {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    display: block;
    content: "";
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 100%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    opacity: 0;
  }
  .usefull-info-image figure:hover::before {
    -webkit-animation: circle 0.75s;
    animation: circle 0.75s;
  }
`;

const Games = styled.section`
  margin-top: 3rem;
`;

const Results = styled.section`
  margin-top: 3rem;
`;

export default MatchDetailManage;
